// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"1121db31ac55e09c","4509":"23c09af29d8fb4ed","8234":"23c09af29d8fb4ed","9307":"23c09af29d8fb4ed"}[chunkId] + ".css";
};